import axiosInstace from './../providers/Axios';
import { getGiftcardBalance } from '../config/paths';

export const callGetGiftcardBalance = async (cardNumber) => {
  return axiosInstace({
    url: `${getGiftcardBalance}/${cardNumber}`,
    method: 'get',
  });
};
